
import React, { FormEvent } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FormTextarea } from "@/components/ui/form-textarea";

interface VerseFinderFormProps {
  prompt: string;
  isLoading: boolean;
  setPrompt: (value: string) => void;
  handleSubmit: (e: FormEvent) => Promise<void>;
}

const VerseFinderForm: React.FC<VerseFinderFormProps> = ({
  prompt,
  isLoading,
  setPrompt,
  handleSubmit
}) => {
  return (
    <Card id="verse-finder" className="bg-white border-heaven-gold/20 shadow-md mb-6 relative z-20">
      <CardHeader className="pb-4 space-y-3">
        <CardTitle className="text-heaven-gold text-center text-5xl md:text-6xl font-playfair font-bold">What's on your heart?</CardTitle>
        <CardDescription className="text-center text-gray-600 text-base font-bold">
          Share your current situation, and we'll find Scripture to guide, comfort, and inspire you.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <FormTextarea
            placeholder="e.g., 'I need wisdom for a difficult decision' or 'I'm feeling anxious about the future' or 'I want to thank God for His blessings'"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="min-h-[100px] text-base"
          />
          <Button
            type="submit"
            className="w-full bg-heaven-gold hover:bg-heaven-dark-gold text-white font-medium py-6 rounded-md"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Finding verses...
              </>
            ) : (
              "Find Your Verse"
            )}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default VerseFinderForm;
